import React, { Suspense } from 'react';
import { useModalContext } from 'contexts/ModalContext/ModalContext';
import { ModalsEnum } from 'types/enums';
import CreateCollectionModal from './CreateCollectionModal/CreateCollectionModal';
import CreditsWarning from './CreditsWarning/CreditsWarning';
import DeleteCollectionModal from './DeleteCollectionModal/DeleteCollectionModal';
import EditCollectionModal from './EditCollectionModal/EditCollectionModal';
import FreeUserFreeDownloadUpsell from './UpsellModals/FreeUserFreeDownloadUpsell';
import {
    FreeUserPaidDownloadUpsell,
    PaidUserPaidDownloadUpsell,
} from './UpsellModals/PaidDownloadUpsell';
import PoorStandingOrSuspended from './PoorStandingOrSuspended/PoorStandingOrSuspended';
import RemoveSamplesFromCollection from './RemoveSamplesFromCollection/RemoveSamplesFromCollection';
import KeyboardCheatSheet from './KeyboardCheatSheet/KeyboardCheatSheet';
import SweetenerUpsellModal from './SweetenerUpsellModal/SweetenerUpsellModal';
import PlanPausedModal from './PlanPaused/PlanPaused';
import ActivateTrialSubscriptionModal from './ActivateTrialSubscriptionModal/ActivateTrialSubscriptionModal';

const Modals = (): JSX.Element => {
    const { closeModal, isModalVisible } = useModalContext();

    return (
        <Suspense fallback={null}>
            <CreateCollectionModal
                isOpen={isModalVisible[ModalsEnum.createCollectionModal]}
                handleClose={closeModal[ModalsEnum.createCollectionModal]}
            />
            <CreditsWarning
                isOpen={isModalVisible[ModalsEnum.creditsWarning]}
                handleClose={closeModal[ModalsEnum.creditsWarning]}
            />
            <DeleteCollectionModal
                isOpen={isModalVisible[ModalsEnum.deleteCollectionModal]}
                handleClose={closeModal[ModalsEnum.deleteCollectionModal]}
            />
            <EditCollectionModal
                isOpen={isModalVisible[ModalsEnum.editCollectionModal]}
                handleClose={closeModal[ModalsEnum.editCollectionModal]}
            />
            <FreeUserFreeDownloadUpsell
                isOpen={isModalVisible[ModalsEnum.freeUserFreeDownloadUpsell]}
                handleClose={closeModal[ModalsEnum.freeUserFreeDownloadUpsell]}
            />
            <FreeUserPaidDownloadUpsell
                isOpen={isModalVisible[ModalsEnum.freeUserPaidDownloadUpsell]}
                handleClose={closeModal[ModalsEnum.freeUserPaidDownloadUpsell]}
            />
            <PaidUserPaidDownloadUpsell
                isOpen={isModalVisible[ModalsEnum.paidUserPaidDownloadUpsell]}
                handleClose={closeModal[ModalsEnum.paidUserPaidDownloadUpsell]}
            />
            <PoorStandingOrSuspended
                isOpen={isModalVisible[ModalsEnum.poorStandingOrSuspended]}
                handleClose={closeModal[ModalsEnum.poorStandingOrSuspended]}
            />
            <RemoveSamplesFromCollection
                isOpen={isModalVisible[ModalsEnum.removeSamplesFromCollection]}
                handleClose={closeModal[ModalsEnum.removeSamplesFromCollection]}
            />
            <KeyboardCheatSheet
                isOpen={isModalVisible[ModalsEnum.keyboardCheatSheet]}
                handleClose={closeModal[ModalsEnum.keyboardCheatSheet]}
            />
            <SweetenerUpsellModal
                isOpen={isModalVisible[ModalsEnum.sweetenerUpsellModal]}
                handleClose={closeModal[ModalsEnum.sweetenerUpsellModal]}
            />
            <PlanPausedModal
                isOpen={isModalVisible[ModalsEnum.planPaused]}
                handleClose={closeModal[ModalsEnum.planPaused]}
            />
            <ActivateTrialSubscriptionModal
                isOpen={isModalVisible[ModalsEnum.activateTrialSubscription]}
                handleClose={closeModal[ModalsEnum.activateTrialSubscription]}
            />
        </Suspense>
    );
};

export default React.memo(Modals);
